import "ol/ol.css";
import { Style, Stroke, Fill, Text } from "ol/style.js";
import ApiService from "services/ApiService";
import { setSourceForGeoJSON } from "map/OlExtension";
import "ol/ol.css";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";

export default class LayerForFutureFuc extends VectorLayer {
    constructor(map) {
        super({
            name: "layerForFutureFuc",
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setGeoJson();
    }

    setGeoJson = function () {
        const layer = this;

        ApiService.get("newdashboard/gis/GetSelfDrivingLink").then(
            (response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setSourceForGeoJSON(layer, data);
                }
            }
        );
    };
    //미래 교통 스타일 - 혜수
    getDefaultStyle = (feature) => {
        return new Style({
            stroke: new Stroke({
                // color: "rgba(255, 255, 255, 0.4)",
                color: "rgba(175, 230, 245, 0.4)",
                lineCap: "round",
                lineJoin: "round",
                lineDash: null,
                lineDashOffset: 0,
                miterLimit: 10,
                width: 15,
            }),
            zIndex: 1,
        });
    };
}
